/* eslint-disable import/max-dependencies */
import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Grid } from "@mui/material";
import PageSettings from "../../containers/PageSettings";
import FloatingControlButtons from "../../containers/FloatingControlButtons";
import { getPageInfo } from "../../selectors/page";
import { mainBackgroundStyles } from "../../styles/common";
import type { State } from "../AppStoreWrapper";

function PageEdit() {
  const { name } = useSelector((state: State) => getPageInfo(state));

  return (
    <>
      <Helmet>
        <title>{`Edit page: ${name}`}</title>
      </Helmet>
      <>
        <Grid
          container
          direction="column"
          sx={mainBackgroundStyles}
        >
          <Grid>
            <PageSettings />
          </Grid>
        </Grid>
        <Grid>
          <FloatingControlButtons />
        </Grid>
      </>
    </>
  );
}

export default PageEdit;
